import { createLogger } from '@immediate_media/logger';
var logger = createLogger('pockets');
export default logger;